/**
 * JSONP Interceptor.
 */

var jsonpClient = require('./client/jsonp');

module.exports = {

    request: function (request) {

        if (request.method == 'JSONP') {
            request.client = jsonpClient;
        }

        return request;
    }

};



/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-resource/src/http/jsonp.js
 ** module id = 167
 ** module chunks = 0
 **/